const MapDirectionData = (  state = [], action  ) => {
    if ( action.type === 'mapdata' ) {
        return action.payload
    } else {
        return state
    }
}
export const InfoBox = (  state = [], action  ) => {
    if ( action.type === 'infobox' ) {
        return action.payload
    } else {
        return state
    }
}
export const MapZoomValue = (  state = 10, action  ) => {
    if ( action.type === 'mapzoom' ) {
        return action.payload
    } else {
        return state
    }
}
export const MadRadius = (  state = 7000000, action  ) => {
    if ( action.type === 'mapradius' ) {
        return action.payload
    } else {
        return state
    }
}
export default MapDirectionData